/**
 * Cart functions
 * ------------------------------------------------------------------------------
 * Functions that should execute everywhere
 *
 */

import {formatMoney} from '@shopify/theme-currency';
import {register} from './../vendor/theme-scripts/theme-sections';
import slideToggle from '../util/slide-toggle';
import slideDown from '../util/slide-down';
import slideUp from '../util/slide-up';
import showElement from '../util/show-element';

const selectors = {
  showCalculator: '.show-calculator',
  shippingCalculator: '#ShippingCalculator',
  showNote: '.show-note',
  note: '#NoteForSeller',
  additionalInsert: '[data-additional-insert]',
  cartAdditional: '[data-cart-additional]',
  cartButton: '#CartButton .cart-count-js',
  cartSubtotal: '.cart__subtotal',
  qtyWrapper: '.js-qty',
  qtyAdjust: '.js-qty__adjust',
  dataNewQty: 'data-new-quantity',
  dataLineKey: 'data-line-key',
  dataCartFormWrapper: 'data-cart-form-wrapper',
  dataVariantId: 'data-variant-id',
  formErrors: '[data-form-errors]',
};

const classes = {
  open: 'open',
  pulseCartIcon: 'pulse-cart-icon',
  qtyDisabled: 'qty--disabled',
  qtyNum: 'js-qty__num',
  qtyPlus: 'js-qty__adjust--plus',
  qtyMinus: 'js-qty__adjust--minus',
};

const sections = {};

class Cart {
  constructor(section) {
    this.init();
    const cartAdditional = document.querySelector(selectors.cartAdditional);
    document.querySelector(selectors.additionalInsert).append(cartAdditional);
    slideDown(cartAdditional);
  }

  init() {
    this.initQuantity();

    document.querySelector(selectors.showCalculator).addEventListener('click', function () {
      slideToggle(document.querySelector(selectors.shippingCalculator));
      this.classList.toggle(classes.open);
    });

    document.querySelector(selectors.showNote).addEventListener('click', function () {
      slideToggle(document.querySelector(selectors.note));
      this.classList.toggle(classes.open);
    });

    Shopify.Cart.ShippingCalculator.show({
      submitButton: theme.strings.shippingCalcSubmitButton,
      submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
      customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
      moneyFormat: theme.strings.shippingCalcMoneyFormat,
    });
  }

  updateHeader() {
    try {
      window
        .fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          const count = response.item_count;
          const cartCount = document.querySelector(selectors.cartButton);
          if (cartCount) {
            cartCount.textContent = count;
            showElement(cartCount);
            cartCount.classList.add(classes.pulseCartIcon);
            setTimeout(function () {
              document.querySelector(selectors.cartButton).classList.remove(classes.pulseCartIcon);
            }, 800);
          }
        });
    } catch (e) {
      console.warn(e);
    }
  }

  initQuantity() {
    const instance = this;
    const adjustButtons = document.querySelectorAll(selectors.qtyAdjust);
    if (adjustButtons) {
      adjustButtons.forEach((element) => {
        element.addEventListener('click', function () {
          const element = this;
          const elementParent = element.closest(selectors.qtyWrapper);
          elementParent.classList.add(classes.qtyDisabled);
          const children = elementParent.children;
          for (const child of children) {
            child.disabled = true;
          }
          const newQuantity = parseInt(element.getAttribute(selectors.dataNewQty));
          const itemKey = element.getAttribute(selectors.dataLineKey);

          instance.changeQuantity('/cart/change.js', newQuantity, itemKey);
        });
      });
    }
  }

  changeQuantity(endpoint, quantity, id) {
    const instance = this;
    const data = {
      quantity: quantity,
      id: id,
    };

    fetch(endpoint, {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        const items = document.querySelectorAll(`[${selectors.dataCartFormWrapper}] [${selectors.dataVariantId}]`);
        const priceElem = document.querySelector(selectors.cartSubtotal);

        if (priceElem) {
          priceElem.textContent = formatMoney(data.total_price, theme.moneyFormat);
        }

        if (data.items.length !== items.length) {
          let flag = false;
          for (const element of items) {
            const elementId = parseInt(element.getAttribute(selectors.dataVariantId));

            for (const [i, dataItem] of data.items.entries()) {
              const dataItemId = dataItem.id;

              if (elementId === dataItemId) {
                break;
              }

              if (elementId !== dataItemId && i === data.items.length - 1) {
                element.parentNode.removeChild(element);
                flag = true;
                break;
              }
            }

            if (flag) {
              break;
            }
          }
        } else {
          for (const element of data.items) {
            const elementId = element.id;
            const elementQty = element.quantity;
            const item = document.querySelector(`[${selectors.dataCartFormWrapper}] [${selectors.dataVariantId}="${elementId}"]`);
            const itemQty = item.querySelector(selectors.qtyWrapper);
            itemQty.classList.remove(classes.qtyDisabled);
            const children = itemQty.children;

            for (const child of children) {
              child.disabled = false;
              if (child.classList.contains(classes.qtyNum)) {
                child.value = elementQty;
              } else if (child.classList.contains(classes.qtyPlus)) {
                child.setAttribute(selectors.dataNewQty, elementQty + 1);
              } else if (child.classList.contains(classes.qtyMinus)) {
                child.setAttribute(selectors.dataNewQty, elementQty - 1);
              }
            }
          }
        }

        instance.init();
        instance.updateHeader();
      })
      .catch((error) => {
        const errors = document.querySelector(selectors.formErrors);
        while (errors.firstChild) errors.removeChild(errors.firstChild);
        slideUp(errors, 100);
        errors.innerHTML = error;
        setTimeout(function () {
          slideDown(errors);
        }, 100);
      });
  }
}

const CartSection = {
  onLoad() {
    sections[this.id] = new Cart(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

register('cart', CartSection);
